import { useImmer } from "use-immer";
import ApiConnector from "../connector/ApiConnector";
import UtilService from "../service/UtilService";
import { useEffect, useState, useRef } from "react";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import OdometerAutoUpdateGeneralConfig from "../component/adminPage/OdometerAutoUpdateGeneralConfig";
import HotspotAutoUpdateGeneralConfig from "../component/adminPage/HotspotAutoUpdateGeneralConfig";
import RuleSuppressGeneralConfig from "../component/adminPage/RuleSuppressGeneralConfig";
import DirectPurchaseGeneralConfig from "../component/adminPage/DirectPurchaseGeneralConfig";
import DaytimeAutoUpdateGeneralConfig from "../component/adminPage/DaytimeAutoUpdateGeneralConfig";
import VolumeAutoUpdateGeneralConfig from "../component/adminPage/VolumeRuleAutoUpdateGeneralConfig";
import CustomerOriginAutoUpdateGeneralConfig from "../component/adminPage/CustomerOriginAutoUpdateGeneralConfig";
import CardAgeAutoUpdateGeneralConfig from "../component/adminPage/CardAgeAutoUpdateGeneralConfig";
import { Link } from "react-router-dom";
import Note from "../component/Note";
import AutoDeclineAutoUpdateGeneralConfig from "../component/adminPage/AutoDeclineAutoUpdateGeneralConfig";
import NotificationGeneralConfig from "../component/adminPage/NotificationGeneralConfig";
import GeneralConfigService from "../service/GeneralConfigService";
import FacilityAutoUpdateGeneralConfig from "../component/adminPage/FacilityAutoUpdateGeneralConfig";
import CountryAutoUpdateGeneralConfig from "../component/adminPage/CountryAutoUpdateGeneralConfig";
import KillSwitchRedundantGeneralConfig from "../component/adminPage/KillSwitchRedundantGeneralConfig";
import CompromisedPanAutoUpdateGeneralConfig from "../component/adminPage/CompromisedPanAutoUpdateGeneralConfig";
import SimulationUpdateGeneralConfig from "../component/adminPage/SimulationUpdateGeneralConfig";
import moment from "moment";
import SuccessStatisticsUpdateGeneralConfig from "../component/adminPage/SuccessStatisticsUpdateGeneralConfig";
import RuleImpactUpdateGeneralConfig from "../component/adminPage/RuleImpactUpdateGeneralConfig";
import WeightUpdateGeneralConfig from "../component/adminPage/WeightUpdateGeneralConfig";
import QualityGateGeneralConfig from "../component/adminPage/QualityGateGeneralConfig";
import { faFloppyDisk } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesDown } from "@fortawesome/free-solid-svg-icons/faAnglesDown";
import { faAnglesUp } from "@fortawesome/free-solid-svg-icons/faAnglesUp";
import { useTableModel } from "../service/TableModelUtilService";
import { normalizeRowsForSignature as baseNormalizeRows } from "../service/NormalizeForSignatureUtilService";
import CustomerHistoryPatternConfig from "../component/adminPage/CustomerHistoryPatternConfig";
import BacktesterUpdateGeneralConfig from "../component/adminPage/BacktesterUpdateGeneralConfig";

const normalizeAdminRowsForSignature = (rows) =>
  baseNormalizeRows(
    rows.map((r) => {
      const d = JSON.parse(JSON.stringify(r));
      const rs = d?.generalConfig?.ruleSuppressConfig;
      if (rs && "autoAllow" in rs) {
        const v = rs.autoAllow;
        const isOff =
          v === false || v === 0 || v === "0" || v === "false" || v == null;
        const isOn =
          v === true || v === 1 || v === "1" || v === "true";
        if (isOff) delete rs.autoAllow;
        else if (isOn) rs.autoAllow = true;
      }
      return d;
    })
  );

const Component = (props) => {
  const [data, updateData] = useImmer(null);
  const [ruleInfoItems, updateRuleInfoItems] = useImmer([]);
  const [expandAll, setExpandAll] = useState(() => {
    const saved = sessionStorage.getItem('adminExpandAll');
    return saved ? JSON.parse(saved) : false;
  });
  const [adminSettingsOpen, setAdminSettingsOpen] = useState(() => {
    const saved = sessionStorage.getItem('adminSettingsOpen');
    return saved ? JSON.parse(saved) : false;
  });
  const containerRef = useRef(null);
  const skipEffectRef = useRef(false);
  const stateLoadedRef = useRef(false);
  const manualCheckboxChangeRef = useRef(false);

  const [generalConfigInfoOpen, setGeneralConfigInfoOpen] = useState(false);
  const [ruleSuppressInfoOpen, setRuleSuppressInfoOpen] = useState(false);
  const [directPurchaseInfoOpen, setDirectPurchaseInfoOpen] = useState(false);
  const [merchantSuppressInfoOpen, setMerchantSuppressInfoOpen] = useState(false);
  const [notificationInfoOpen, setNotificationInfoOpen] = useState(false);
  const [autoDeclineInfoOpen, setAutoDeclineInfoOpen] = useState(false);
  const [autoDeclineAutoUpdateInfoOpen, setAutoDeclineAutoUpdateInfoOpen] = useState(false);
  const [cardAgeRuleAutoUpdateInfoOpen, setCardAgeRuleAutoUpdateInfoOpen] = useState(false);
  const [compromisedPanRuleAutoUpdateInfoOpen, setCompromisedPanRuleAutoUpdateInfoOpen] = useState(false);
  const [countryRuleAutoUpdateInfoOpen, setCountryRuleAutoUpdateInfoOpen] = useState(false);
  const [customerOriginRuleAutoUpdateInfoOpen, setCustomerOriginRuleAutoUpdateInfoOpen] = useState(false);
  const [daytimeRuleAutoUpdateInfoOpen, setDaytimeRuleAutoUpdateInfoOpen] = useState(false);
  const [hotspotRuleAutoUpdateInfoOpen, setHotspotRuleAutoUpdateInfoOpen] = useState(false);
  const [facilityRuleAutoUpdateInfoOpen, setFacilityRuleAutoUpdateInfoOpen] = useState(false);
  const [odometerRuleAutoUpdateInfoOpen, setOdometerRuleAutoUpdateInfoOpen] = useState(false);
  const [volumeRuleAutoUpdateInfoOpen, setVolumeRuleAutoUpdateInfoOpen] = useState(false);
  const [simulationJobInfoOpen, setSimulationJobInfoOpen] = useState(false);
  const [successStatisticsInfoOpen, setSuccessStatisticsInfoOpen] = useState(false);
  const [ruleImpactUpdateInfoOpen, setRuleImpactUpdateInfoOpen] = useState(false);
  const [weightsAutoUpdateInfoOpen, setWeightsAutoUpdateInfoOpen] = useState(false);
  const [qualityGateInfoOpen, setQualityGateInfoOpen] = useState(false);
  const [customerHistoryPatternInfoOpen, setCustomerHistoryPatternInfoOpen] = useState(false);
  const [redundantKillSwitchInfoOpen, setRedundantKillSwitchInfoOpen] = useState(false);
  const [backtesterUpdateInfoOpen, setBacktesterUpdateInfoOpen] = useState(false);

  const handleInfoIconClick = (detailsId, isOpen, setOpen) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const detailsElement = document.getElementById(detailsId);
    if (detailsElement && !detailsElement.open) {
      detailsElement.open = true;
      setOpen(true);
    } else {
      setOpen(!isOpen);
    }
  };

  const { canSave, setRows: setModelRows, setBaselineFromRows } = useTableModel({
    initialRows: [],
    columns: [],
    keyField: "_key",
    initialSortBy: null,
    initialSortDir: "asc",
    normalizeForSignature: normalizeAdminRowsForSignature,
  });

  useEffect(() => {
    (async () => {
      const ruleInfo = await ApiConnector.getRuleInfo(
        moment().subtract(10, "days").format("YYYY-MM-DDTHH:mm:ss") + "Z",
        moment().format("YYYY-MM-DDTHH:mm:ss") + "Z",
      );
      updateRuleInfoItems(ruleInfo.ruleInfoItems);
      await loadLatestGeneralConfig();
    })();

    return () => {
      stateLoadedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (data) setModelRows([data]);
  }, [data]);

  useEffect(() => {
    sessionStorage.setItem('adminExpandAll', JSON.stringify(expandAll));
  }, [expandAll]);

  useEffect(() => {
    sessionStorage.setItem('adminSettingsOpen', JSON.stringify(adminSettingsOpen));
  }, [adminSettingsOpen]);

  // Load state from sessionStorage when data is available
  useEffect(() => {
    if (!data) return;

    const timer = setTimeout(() => {
      if (containerRef.current && !stateLoadedRef.current) {
        const savedState = sessionStorage.getItem('adminDetailsState');
        if (savedState) {
          try {
            const openStates = JSON.parse(savedState);
            const details = containerRef.current.querySelectorAll('details.config-section');
            details.forEach((detail) => {
              const sectionId = detail.getAttribute('data-section-id');
              if (sectionId && openStates[sectionId] !== undefined) {
                detail.open = openStates[sectionId];
              }
            });
            stateLoadedRef.current = true;
          } catch (e) {
            console.error('Failed to restore details state:', e);
          }
        } else {
          stateLoadedRef.current = true;
        }
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [data]);

  // Handle expandAll changes
  useEffect(() => {
    if (skipEffectRef.current) {
      skipEffectRef.current = false;
      return;
    }
    if (containerRef.current) {
      const details = containerRef.current.querySelectorAll('details.config-section');
      details.forEach(detail => {
        detail.open = expandAll;
      });
      setTimeout(() => {
        const openStates = {};
        details.forEach((detail) => {
          const sectionId = detail.getAttribute('data-section-id');
          if (sectionId) {
            openStates[sectionId] = detail.open;
          }
        });
        sessionStorage.setItem('adminDetailsState', JSON.stringify(openStates));
      }, 150);
    }
  }, [expandAll]);

  // Listen for toggle events to save state
  useEffect(() => {
    if (!containerRef.current) return;

    const handleToggle = () => {
      const details = containerRef.current.querySelectorAll('details.config-section');
      const openStates = {};
      details.forEach((detail) => {
        const sectionId = detail.getAttribute('data-section-id');
        if (sectionId) {
          openStates[sectionId] = detail.open;
        }
      });
      sessionStorage.setItem('adminDetailsState', JSON.stringify(openStates));

      // Check if all are open and update expandAll if needed
      if (expandAll) {
        const allOpen = Array.from(details).every(detail => detail.open);
        if (!allOpen) {
          if (!manualCheckboxChangeRef.current) {
            skipEffectRef.current = true;
            setExpandAll(false);
          }
          manualCheckboxChangeRef.current = false;
        }
      }
    };

    const details = containerRef.current.querySelectorAll('details.config-section');
    details.forEach(detail => {
      detail.addEventListener('toggle', handleToggle);
    });

    return () => {
      details.forEach(detail => {
        detail.removeEventListener('toggle', handleToggle);
      });
    };
  }, [data, expandAll]);

  const loadLatestGeneralConfig = async () => {
    const t = await ApiConnector.getLatestGeneralConfig();
    updateData(t);
    setModelRows([t]);
    setBaselineFromRows([t]);
  };

  const createGeneralConfig = async () => {
    if (!data || !canSave) return;
    const newConfig = await GeneralConfigService.createGeneralConfig(
      data,
      data.id,
    );
    if (!newConfig) return;
    updateData(newConfig);
    setModelRows([newConfig]);
    setBaselineFromRows([newConfig]);
  };

  return (
    data && (
      <>
        <header className="subheader header-with-save">
          <h1 className="header-title">Admin</h1>
          <span className="header-save">
            <FontAwesomeIcon
              icon={faFloppyDisk}
              size="2xl"
              className="icon-clickable"
              onClick={canSave ? createGeneralConfig : undefined}
              title={canSave ? "Save changes" : "No changes to save"}
              style={{
                opacity: canSave ? 1 : 0.4,
                cursor: canSave ? "pointer" : "not-allowed",
                pointerEvents: canSave ? "auto" : "none",
              }}
              aria-disabled={!canSave}
            />
          </span>
        </header>
        <main>
          <div className="row">
            <div className="col">
              <h2>General config</h2>
            </div>
            <div className="col">
              <h2 className="float-right" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Note noteTargetPath="generalConfig" noteTargetId={data.id} />
                <FontAwesomeIcon
                  icon={faCircleQuestion}
                  className="info-icon"
                  onClick={handleInfoIconClick('generalConfig-details', generalConfigInfoOpen, setGeneralConfigInfoOpen)}
                  title={generalConfigInfoOpen ? "Hide info" : "Show info"}
                />
              </h2>
            </div>
          </div>

          {generalConfigInfoOpen && (
            <div className="info-box">
              <p>
                <strong>Tracks all configuration changes</strong>, including manual user edits and automated system updates.
                Every change creates a new versioned "config" and logs the User ID responsible for the modification.
              </p>
            </div>
          )}

          <table className="config-table">
            <thead>
            <tr>
              <th>Attribute</th>
              <th>Value</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Id</td>
              <td>{data.id}</td>
            </tr>
            <tr>
              <td>Created</td>
              <td>{UtilService.isoDateToReadable(data.created)}</td>
            </tr>
            <tr>
              <td>User id</td>
              <td>{data.userId}</td>
            </tr>
            </tbody>
          </table>

          <details ref={containerRef} open={adminSettingsOpen} onToggle={(e) => {
            if (e.target === e.currentTarget) {
              const isOpen = e.target.open;
              setAdminSettingsOpen(isOpen);
              sessionStorage.setItem('adminSettingsOpen', JSON.stringify(isOpen));
            }
          }}>
            <summary>
              <h2>
                Admin config
                <span className="float-right" style={{ marginRight: '7px' }}>
                  <label style={{ cursor: 'pointer', fontSize: '1.1rem', fontWeight: 'normal', display: 'flex', alignItems: 'center', gap: '8px' }} onClick={(e) => e.stopPropagation()}>
                    <FontAwesomeIcon icon={expandAll ? faAnglesUp : faAnglesDown} />
                    <input
                      type="checkbox"
                      checked={expandAll}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        manualCheckboxChangeRef.current = true;
                        setExpandAll(checked);
                        setAdminSettingsOpen(checked);
                      }}
                      style={{ transform: 'scale(1.3)', cursor: 'pointer' }}
                    />
                  </label>
                </span>
              </h2>
            </summary>

          <details className="config-section" data-section-id="ruleSuppress" id="ruleSuppress-details">
            <summary>
              <h3>
                Rule suppress
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.ruleSuppress"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('ruleSuppress-details', ruleSuppressInfoOpen, setRuleSuppressInfoOpen)}
                    title={ruleSuppressInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {ruleSuppressInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Disables specific rule;</strong> disabled rules are temporarily not included in the risk evaluation.
                  It's advised not to disable rules when unnecessary. This feature server as a failsafe in case specific rule malfunctions.
                </p>
              </div>
            )}

            <RuleSuppressGeneralConfig
              config={data.generalConfig.ruleSuppressConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.ruleSuppressConfig = val;
                })
              }
            />
          </details>

          <details className="config-section" data-section-id="directPurchase" id="directPurchase-details">
            <summary>
              <h3>
                Direct purchase
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.directPurchase"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('directPurchase-details', directPurchaseInfoOpen, setDirectPurchaseInfoOpen)}
                    title={directPurchaseInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {directPurchaseInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Direct purchase evaluation feature switch;</strong> when disabled, incoming direct purchase transactions
                  are not risk evaluated at all - they are stored and returned as approved. Serves as an emergency failsafe
                  to turn off direct purchase evaluation on production. Pre-authorization transactions are not affected.
                </p>
              </div>
            )}

            <DirectPurchaseGeneralConfig
              config={data.generalConfig.directPurchaseConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.directPurchaseConfig = val;
                })
              }
            />
          </details>

          <details className="config-section" data-section-id="merchantSuppress" id="merchantSuppress-details">
            <summary>
              <h3>
                Merchant suppress
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.merchantSuppress"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('merchantSuppress-details', merchantSuppressInfoOpen, setMerchantSuppressInfoOpen)}
                    title={merchantSuppressInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {merchantSuppressInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Bypasses Risk Evaluation</strong> for specific merchants or terminals while still enforcing "Auto Decline" rules.
                  If a suppressed merchant's transaction passes the Auto Decline check, it is marked as "Approved by merchant code suppress";
                  otherwise, it is declined normally.
                </p>
              </div>
            )}

            <table className="config-table">
              <thead>
              <tr>
                <th>Attribute</th>
                <th>
                  Value <small>[substrings]</small>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Merchant codes</td>
                <td>
                  <input
                    type="text"
                    value={UtilService.arrayToCsv(
                      data.generalConfig.suppressConfig.merchantCodeSuppresses,
                      true,
                    )}
                    onChange={(e) =>
                      updateData((d) => {
                        d.generalConfig.suppressConfig.merchantCodeSuppresses =
                          UtilService.csvToStringArray(e.target.value);
                      })
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Terminal ids</td>
                <td>
                  <input
                    type="text"
                    value={UtilService.arrayToCsv(
                      data.generalConfig.suppressConfig.terminalIdSuppresses,
                      true,
                    )}
                    onChange={(e) =>
                      updateData((d) => {
                        d.generalConfig.suppressConfig.terminalIdSuppresses =
                          UtilService.csvToStringArray(e.target.value);
                      })
                    }
                  />
                </td>
              </tr>
              </tbody>
            </table>
          </details>

          <details className="config-section" data-section-id="notificationOfCustomer" id="notificationOfCustomer-details">
            <summary>
              <h3>
                Notification of customer
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.notification"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('notificationOfCustomer-details', notificationInfoOpen, setNotificationInfoOpen)}
                    title={notificationInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {notificationInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Not in use, will be re-worked.</strong>
                </p>
              </div>
            )}

            <NotificationGeneralConfig
              config={data.generalConfig.notificationConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.notificationConfig = val;
                })
              }
            ></NotificationGeneralConfig>
          </details>

          <details className="config-section" data-section-id="autoDecline" id="autoDecline-details">
            <summary>
              <h3>
                Auto decline
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.autoDecline"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('autoDecline-details', autoDeclineInfoOpen, setAutoDeclineInfoOpen)}
                    title={autoDeclineInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {autoDeclineInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Directly blocks transactions</strong> based on specific criteria (LPN, Merchant, Terminal, Daytime) before they reach
                  the main Rule engine. It allows for precise blocking, such as stopping a specific vehicle entirely, or only when that
                  vehicle visits a specific merchant.
                </p>
              </div>
            )}

            <p>
              Definition of hard rules used to automatically decline transaction.
            </p>
            <Link className="" to="/admin/auto-decline">
              View detail
            </Link>
          </details>

          <details className="config-section" data-section-id="autoDeclineAutoUpdate" id="autoDeclineAutoUpdate-details">
            <summary>
              <h3>
                Auto decline auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.autoDeclineAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('autoDeclineAutoUpdate-details', autoDeclineAutoUpdateInfoOpen, setAutoDeclineAutoUpdateInfoOpen)}
                    title={autoDeclineAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {autoDeclineAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <AutoDeclineAutoUpdateGeneralConfig
              config={data.generalConfig.autoDeclineAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.autoDeclineAutoUpdateConfig = val;
                })
              }
            ></AutoDeclineAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="cardAgeRuleAutoUpdate" id="cardAgeRuleAutoUpdate-details">
            <summary>
              <h3>
                Card age rule auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.cardAgeRuleAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('cardAgeRuleAutoUpdate-details', cardAgeRuleAutoUpdateInfoOpen, setCardAgeRuleAutoUpdateInfoOpen)}
                    title={cardAgeRuleAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {cardAgeRuleAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <CardAgeAutoUpdateGeneralConfig
              config={data.generalConfig.cardAgeAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.cardAgeAutoUpdateConfig = val;
                })
              }
            ></CardAgeAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="compromisedPanRuleAutoUpdate" id="compromisedPanRuleAutoUpdate-details">
            <summary>
              <h3>
                Compromised pan rule auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.compromisedPanRuleAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('compromisedPanRuleAutoUpdate-details', compromisedPanRuleAutoUpdateInfoOpen, setCompromisedPanRuleAutoUpdateInfoOpen)}
                    title={compromisedPanRuleAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {compromisedPanRuleAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <CompromisedPanAutoUpdateGeneralConfig
              config={data.generalConfig.compromisedPanAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.compromisedPanAutoUpdateConfig = val;
                })
              }
            ></CompromisedPanAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="countryRuleAutoUpdate" id="countryRuleAutoUpdate-details">
            <summary>
              <h3>
                Country rule auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.countryRuleAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('countryRuleAutoUpdate-details', countryRuleAutoUpdateInfoOpen, setCountryRuleAutoUpdateInfoOpen)}
                    title={countryRuleAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {countryRuleAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <CountryAutoUpdateGeneralConfig
              config={data.generalConfig.countryAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.countryAutoUpdateConfig = val;
                })
              }
            ></CountryAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="customerOriginRuleAutoUpdate" id="customerOriginRuleAutoUpdate-details">
            <summary>
              <h3>
                Customer origin rule auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.customerOriginRuleAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('customerOriginRuleAutoUpdate-details', customerOriginRuleAutoUpdateInfoOpen, setCustomerOriginRuleAutoUpdateInfoOpen)}
                    title={customerOriginRuleAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {customerOriginRuleAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <CustomerOriginAutoUpdateGeneralConfig
              config={data.generalConfig.customerOriginAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.customerOriginAutoUpdateConfig = val;
                })
              }
            ></CustomerOriginAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="daytimeRuleAutoUpdate" id="daytimeRuleAutoUpdate-details">
            <summary>
              <h3>
                Daytime rule auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.daytimeRuleAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('daytimeRuleAutoUpdate-details', daytimeRuleAutoUpdateInfoOpen, setDaytimeRuleAutoUpdateInfoOpen)}
                    title={daytimeRuleAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {daytimeRuleAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <DaytimeAutoUpdateGeneralConfig
              config={data.generalConfig.daytimeAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.daytimeAutoUpdateConfig = val;
                })
              }
            ></DaytimeAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="hotspotRuleAutoUpdate" id="hotspotRuleAutoUpdate-details">
            <summary>
              <h3>
                Hotspot rule auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.hotspotRuleAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('hotspotRuleAutoUpdate-details', hotspotRuleAutoUpdateInfoOpen, setHotspotRuleAutoUpdateInfoOpen)}
                    title={hotspotRuleAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {hotspotRuleAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <HotspotAutoUpdateGeneralConfig
              config={data.generalConfig.hotspotAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.hotspotAutoUpdateConfig = val;
                })
              }
            ></HotspotAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="facilityRuleAutoUpdate" id="facilityRuleAutoUpdate-details">
            <summary>
              <h3>
                Facility rule auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.facilityRuleAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('facilityRuleAutoUpdate-details', facilityRuleAutoUpdateInfoOpen, setFacilityRuleAutoUpdateInfoOpen)}
                    title={facilityRuleAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {facilityRuleAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <FacilityAutoUpdateGeneralConfig
              config={data.generalConfig.facilityAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.facilityAutoUpdateConfig = val;
                })
              }
            ></FacilityAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="odometerRuleAutoUpdate" id="odometerRuleAutoUpdate-details">
            <summary>
              <h3>
                Odometer rule auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.odometerRuleAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('odometerRuleAutoUpdate-details', odometerRuleAutoUpdateInfoOpen, setOdometerRuleAutoUpdateInfoOpen)}
                    title={odometerRuleAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {odometerRuleAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <OdometerAutoUpdateGeneralConfig
              config={data.generalConfig.odometerAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.odometerAutoUpdateConfig = val;
                })
              }
            ></OdometerAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="volumeRuleAutoUpdate" id="volumeRuleAutoUpdate-details">
            <summary>
              <h3>
                Volume rule auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.volumeRuleAutoUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('volumeRuleAutoUpdate-details', volumeRuleAutoUpdateInfoOpen, setVolumeRuleAutoUpdateInfoOpen)}
                    title={volumeRuleAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {volumeRuleAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered.
                  It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible.
                  Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <VolumeAutoUpdateGeneralConfig
              config={data.generalConfig.volumeAutoUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.volumeAutoUpdateConfig = val;
                })
              }
            ></VolumeAutoUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="simulationJobAutoUpdate" id="simulationJobAutoUpdate-details">
            <summary>
              <h3>
                Simulation job auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.simulationUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('simulationJobAutoUpdate-details', simulationJobInfoOpen, setSimulationJobInfoOpen)}
                    title={simulationJobInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {simulationJobInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Automates the optimization of rule weights</strong> on a daily basis. It runs simulation jobs during selected times
                  to test various scenarios, then analyzes the results to identify the "best" weight set. This optimal set is automatically
                  applied as the active configuration.
                </p>
              </div>
            )}

            <SimulationUpdateGeneralConfig
              config={data.generalConfig.simulationUpdateConfig}
              ruleInfoItems={ruleInfoItems}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.simulationUpdateConfig = val;
                })
              }
            ></SimulationUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="successStatisticsUpdate" id="successStatisticsUpdate-details">
            <summary>
              <h3>
                Success statistics update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.successStatisticsUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('successStatisticsUpdate-details', successStatisticsInfoOpen, setSuccessStatisticsInfoOpen)}
                    title={successStatisticsInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {successStatisticsInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Configures the automated reporting</strong> of system performance by setting the historical window (in months) and
                  a "minimal delay" buffer. This buffer shifts the reporting period (e.g., creating a 3-day lag) to ensure operations teams
                  have sufficient time to confirm and mark fraud cases before the statistics are finalized.
                </p>
              </div>
            )}

            <SuccessStatisticsUpdateGeneralConfig
              config={data.generalConfig.successStatisticsUpdateConfig}
              ruleInfoItems={ruleInfoItems}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.successStatisticsUpdateConfig = val;
                })
              }
            ></SuccessStatisticsUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="ruleImpactUpdate" id="ruleImpactUpdate-details">
            <summary>
              <h3>
                Rule impact analysis update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.ruleImpactUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('ruleImpactUpdate-details', ruleImpactUpdateInfoOpen, setRuleImpactUpdateInfoOpen)}
                    title={ruleImpactUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {ruleImpactUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Configures the Rule Impact Analysis cache.</strong> Defines the transaction date range
                  and the schedule for automatic recomputation. Use <em>Analyze now</em> to trigger an immediate
                  refresh. The dashboard widget reads from this cache and updates automatically when a new result
                  is available.
                </p>
              </div>
            )}

            <RuleImpactUpdateGeneralConfig
              config={data.generalConfig.ruleImpactUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.ruleImpactUpdateConfig = val;
                })
              }
            ></RuleImpactUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="backtesterUpdate" id="backtesterUpdate-details">
            <summary>
              <h3>
                Backtester dataset update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.backtesterUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('backtesterUpdate-details', backtesterUpdateInfoOpen, setBacktesterUpdateInfoOpen)}
                    title={backtesterUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {backtesterUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Schedules the Backtester dataset rebuild.</strong> Defines on which days and at what time
                  the risk-array cache is rebuilt from production transactions, and how many days of history the
                  dataset covers. The Backtester page evaluates weight sets against this cached dataset.
                </p>
              </div>
            )}

            <BacktesterUpdateGeneralConfig
              config={data.generalConfig.backtesterUpdateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.backtesterUpdateConfig = val;
                })
              }
            ></BacktesterUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="weightsAutoUpdate" id="weightsAutoUpdate-details">
            <summary>
              <h3>
                Weights auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.simulationUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('weightsAutoUpdate-details', weightsAutoUpdateInfoOpen, setWeightsAutoUpdateInfoOpen)}
                    title={weightsAutoUpdateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {weightsAutoUpdateInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Selects and applies the optimal rule weights</strong> by analyzing "PABLO" jobs from a defined history window.
                  It enforces strict quality controls, such as minimum thresholds for total iterations and true positives, to ensure reliability.
                  If these thresholds aren't met, the update aborts, indicating a need to adjust sensitivity criteria (e.g., tightening True
                  Positive/False Positive limits) to force more rigorous testing.
                </p>
              </div>
            )}

            <WeightUpdateGeneralConfig
              config={data.generalConfig.weightUpdateConfig}
              ruleInfoItems={ruleInfoItems}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.weightUpdateConfig = val;
                })
              }
            ></WeightUpdateGeneralConfig>
          </details>

          <details className="config-section" data-section-id="qualityGate" id="qualityGate-details">
            <summary>
              <h3>
                Quality Gate
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.qualityGate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('qualityGate-details', qualityGateInfoOpen, setQualityGateInfoOpen)}
                    title={qualityGateInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {qualityGateInfoOpen && (
              <div className="info-box">
                <p>
                  Validates simulation results before applying new weights. If the effective TP rate does not meet
                  the required threshold for the given fraud volume, the existing config is kept and a Slack alert is sent.
                </p>
              </div>
            )}

            <QualityGateGeneralConfig
              config={data.generalConfig.qualityGateConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.qualityGateConfig = val;
                })
              }
            />
          </details>

          <details className="config-section" data-section-id="customerHistoryPatternAutoUpdate" id="customerHistoryPatternAutoUpdate-details">
            <summary>
              <h3>
                Customer history pattern auto update
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.customerHistoryUpdate"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('customerHistoryPatternAutoUpdate-details', customerHistoryPatternInfoOpen, setCustomerHistoryPatternInfoOpen)}
                    title={customerHistoryPatternInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {customerHistoryPatternInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Provides the option</strong> to set up when the auto update feature for individual rules is triggered. It's advised to keep the time frames phased, so that auto update runs only for a single run at a time, if possible. Additional metrics can be set up for some rules.
                </p>
              </div>
            )}

            <CustomerHistoryPatternConfig
              config={data.generalConfig.customerHistoryPatternUpdateConfig}
              ruleInfoItems={ruleInfoItems}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.customerHistoryPatternUpdateConfig = val;
                })
              }
            ></CustomerHistoryPatternConfig>
          </details>

          <details className="config-section" data-section-id="redundantKillSwitch" id="redundantKillSwitch-details">
            <summary>
              <h3>
                Redundant Kill switch
                <span className="section-header-icons">
                  <Note
                    noteTargetPath="generalConfig.killSwitchRedundant"
                    noteTargetId={data.id}
                  />
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="info-icon"
                    onClick={handleInfoIconClick('redundantKillSwitch-details', redundantKillSwitchInfoOpen, setRedundantKillSwitchInfoOpen)}
                    title={redundantKillSwitchInfoOpen ? "Hide info" : "Show info"}
                  />
                </span>
              </h3>
            </summary>

            {redundantKillSwitchInfoOpen && (
              <div className="info-box">
                <p>
                  <strong>Acts as a fail-safe backup</strong> to the main Kill Switch to prevent serious production incidents. It has two modes:
                  a hardcoded "Always Approve" to effectively turn Pablo off, and a safety limit that forces approval if the number of declines
                  in the last 24 hours exceeds a set threshold (e.g., 100). This threshold should always be set significantly higher than the
                  main Kill Switch.
                </p>
              </div>
            )}

            <KillSwitchRedundantGeneralConfig
              config={data.generalConfig.killSwitchRedundantConfig}
              onChange={(val) =>
                updateData((d) => {
                  d.generalConfig.killSwitchRedundantConfig = val;
                })
              }
            ></KillSwitchRedundantGeneralConfig>
          </details>
          </details>
        </main>
      </>
    )
  );
};

export default Component;
